<template>
    <div class="legal-landing">
        <p>{{ trans.get("legal.shippingDelivery.text") }}</p>
        <h3>{{ trans.get("legal.shippingDelivery.subtitle1") }}</h3>
        <p>{{ trans.get("legal.shippingDelivery.text2") }}</p>
        <h3>{{ trans.get("legal.shippingDelivery.subtitle2") }}</h3>
        <p>{{ trans.get("legal.shippingDelivery.text3") }}</p>
        <ul>
            <li v-html="trans.get('legal.shippingDelivery.ul1.li1')"></li>
            <li v-html="trans.get('legal.shippingDelivery.ul1.li2')"></li>
            <li v-html="trans.get('legal.shippingDelivery.ul1.li3')"></li>
        </ul>
        <p>{{ trans.get("legal.shippingDelivery.text4") }}</p>
        <h3>{{ trans.get("legal.shippingDelivery.subtitle3") }}</h3>
        <ul>
            <li>
               <b> {{ trans.get("legal.shippingDelivery.ul2.li1") }}</b>
                <ul>
                    <li v-html="trans.get('legal.shippingDelivery.ul2.ul.li1')">
                    </li>
                    <li v-html="trans.get('legal.shippingDelivery.ul2.ul.li2')">
                    </li>
                    <li v-html="trans.get('legal.shippingDelivery.ul2.ul.li3')">
                    </li>
                    <li v-html="trans.get('legal.shippingDelivery.ul2.ul.li4')">
                    </li>
                    <li v-html="trans.get('legal.shippingDelivery.ul2.ul.li5')">
                    </li>
                    <li v-html="trans.get('legal.shippingDelivery.ul2.ul.li6')">
                    </li>
                    <li v-html="trans.get('legal.shippingDelivery.ul2.ul.li7')">
                    </li>
                    <li v-html="trans.get('legal.shippingDelivery.ul2.ul.li8')">
                    </li>
                </ul>
            </li>
            <li v-html="trans.get('legal.shippingDelivery.ul2.li2')"></li>
        </ul>

        <h3>{{ trans.get("legal.shippingDelivery.subtitle4") }}</h3>
        <p>
            {{ trans.get("legal.shippingDelivery.text5") }}
            <a href="https://www.gls-spain.es/es/">{{
                trans.get("legal.shippingDelivery.link1")
            }}</a
            >.
            {{ trans.get("legal.shippingDelivery.text6") }}
            <a
                href="https://www.correos.es/ss/Satellite/site/aplicacion-localizador_envios-localiza_busca_encuentra/detalle_app-sidioma=es_ES"
                >{{ trans.get("legal.shippingDelivery.link2") }}</a
            >
            {{ trans.get("legal.shippingDelivery.text7") }}
        </p>
        <h3>{{ trans.get("legal.shippingDelivery.subtitle5") }}</h3>
        <p>{{ trans.get("legal.shippingDelivery.text8") }}</p>
        <h3>{{ trans.get("legal.shippingDelivery.subtitle6") }}</h3>
        <p>
            {{ trans.get("legal.shippingDelivery.text9") }}
            <a href="/returns-policy">{{
                trans.get("legal.shippingDelivery.link3")
            }}</a
            >.
        </p>

        <h3>{{ trans.get("legal.shippingDelivery.subtitle7") }}</h3>

        <p>{{ trans.get("legal.shippingDelivery.text10") }}</p>
    </div>
</template>

<script>
export default {};
</script>
